import React, {useEffect, useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    putBankAccounts,
    putBasicType,
    putCashRegisters,
    putClient,
    putClientMovements,
    putPOS,
    putPriceList,
    putProduct,
    putProductMovements,
    putSupplier,
    putSupplierMovements,
    putSupplierPayment
} from "../../../_apis/api";
import Dropdown from "../Dropdown";
import Input from "../../common/Input";

const QuickEdit = (props) => {
    const dispatch = useDispatch();

    const formFields = props.columns;

    const [state, setState] = useState({
        isPaneOpen: false,
        isPaneOpenLeft: false,
        editId: props.id,
    });

    const company = useSelector(state => state.COMPANY_DATA.company)
    const [formUpdatedData, setFormUpdatedData] = useState(props.data);

    useEffect(() => {
        setFormUpdatedData(props.data);
    }, [props.data]);

    const requestData = {
        company: company.id,
        year: company.year,
    }

    const handleInputChange = (e, type, name) => {
        if (type === "dd") {
            setFormUpdatedData({...formUpdatedData, [name]: e.value})
        } else if (type === "input") {
            setFormUpdatedData({...formUpdatedData, [name]: e.target.value})
        }
    }

    const handleSave = () => {
        const updateData = {...formUpdatedData, ...requestData};
        updateData.id = updateData._id;

        if (props.tableName && props.tableName === "Sales Products List") {
            dispatch(putProduct(updateData, requestData, 'update'))
        } else if (props.tableName && props.tableName === "Search Products") {
            dispatch(putProduct(updateData, requestData, 'update'))
        } else if (props.tableName && props.tableName === "Search Product Movements") {
            dispatch(putProductMovements(updateData))
        } else if (props.tableName && props.tableName === "Search Product Price List") {
            dispatch(putPriceList(updateData, requestData, 'update'))
        } else if (props.tableName && props.tableName === "Bank Account Search") {
            dispatch(putBankAccounts(updateData, requestData))
        } else if (props.tableName && props.tableName === "POS Search") {
            dispatch(putPOS(updateData, requestData))
        } else if (props.tableName && props.tableName === "Cash Registers Search") {
            dispatch(putCashRegisters(updateData, requestData))
        } else if (props.tableName && props.tableName === "Search Product Movements") {
            dispatch(putProductMovements(updateData))
        } else if (props.tableName && props.tableName === "Basic Types Search") {
            dispatch(putBasicType(updateData, requestData))
        } else if (props.tableName && props.tableName === "Client Search") {
            dispatch(putClient(updateData, requestData, 'update'))
        } else if (props.tableName && props.tableName === "Supplier Search") {
            dispatch(putSupplier(updateData, requestData, 'update'))
        } else if (props.tableName && props.tableName === "Client Movements Search") {
            dispatch(putClientMovements(updateData))
        } else if (props.tableName && props.tableName === "Supplier Movements Search") {
            dispatch(putSupplierMovements(updateData))
        } else if (props.tableName && props.tableName === "Supplier Payments Search") {
            dispatch(putSupplierPayment(updateData))
        } else {
            props.updateData(null, 'edit', updateData);
        }
        setState({...state, isPaneOpen: false});
    }

    return (
        <React.Fragment>
            <Button variant="default" title={props.title ? props.title : "Quick Edit"} onClick={() => setState({...state, isPaneOpen: true})} size="sm">
                <i id={state.editId} className="far fa-edit"></i>
            </Button>

            <Modal show={state.isPaneOpen} onHide={() => setState({...state, isPaneOpen: false})} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Γρήγορη επεξεργασία</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {formFields && formFields.map((item, idx) => {
                            if (item.field === 'actions' || item.field === 'action' || item.field === 'select_checkbox' || item?.hidden) return ''; // Excluding the actions fields from the Quick form

                            let disabledField = false;
                            const disabledFields = ['code', 'systemCode', 'categoryName', 'clientCode', 'date', 'documentTypeName', 'sum', 'products_list'];
                            if (disabledFields.includes(item.field)) disabledField = true;

                            if (["dropdown", "select", "radio", "checkbox"].includes(item.inputType.type)) {
                                return (
                                    <Dropdown
                                        name={item.field}
                                        className={"mb-2"}
                                        label={item.name}
                                        key={item.field + String(idx) + formUpdatedData[item.field]}
                                        defaultValue={item.inputType.options.find((el) => el.value === formUpdatedData[item.field])}
                                        options={item.inputType.options}
                                        disabled={disabledField}
                                        onChange={(e) => handleInputChange(e, "dd", item.field)}
                                    />
                                )
                            } else {
                                return (
                                    <Input
                                        className={"mb-2"}
                                        name={item.field}
                                        label={item.name}
                                        key={item.field + String(idx)}
                                        value={formUpdatedData[item.field]}
                                        disabled={disabledField}
                                        onChange={(e) => handleInputChange(e, "input", item.field)}
                                    />
                                )
                            }
                        })}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setState({...state, isPaneOpen: false})}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => handleSave()}>
                        Αποθήκευση
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default QuickEdit;
